export const TEXTS = {
  CARD_LOADING_TEXT: 'Данные карты загружаются...',
};
